import { render, staticRenderFns } from "./CollectivesInfos.vue?vue&type=template&id=10d81dac&"
import script from "./CollectivesInfos.vue?vue&type=script&lang=js&"
export * from "./CollectivesInfos.vue?vue&type=script&lang=js&"
import style0 from "./CollectivesInfos.vue?vue&type=style&index=0&id=10d81dac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
